import { useMemo } from 'react';
import { config } from '../../config/config';
import { ValueOf } from '../../config/constants';
import { generateChartData, generateChartDataParams } from '../../helpers';
import moment from 'moment';
import { parseEther, formatEther } from 'ethers/lib/utils';

let cachedFees: Record<string, { value: number; time: string }[]> = {};

const startValue = 450_000;

const generateMockData = (
    timeframe: ValueOf<typeof config.areaChartTimeframes>,
    baseValue: number,
    volatility: number,
    cache: Record<string, { value: number; time: string }[]>
) => {
    const key = timeframe as string;
    if (cache[key]) return cache[key];

    const params = generateChartDataParams(timeframe);
    const chartData = generateChartData(
        params.startTime,
        parseEther('0'),
        params.amountToGenerate,
        params.timeInterval
    );

    let currentValue = baseValue * 0.85;
    const data = chartData.map(({ time }) => {
        const change = (Math.random() * 2 - 1) * baseValue * volatility;
        currentValue = Math.max(baseValue * 0.6, Math.min(baseValue * 1.4, currentValue + change));
        return {
            value: currentValue,
            time: moment.unix(time).toISOString(),
        };
    });

    cache[key] = data;
    return data;
};

const useMockHistoricalProtocolFees = (timeframe: ValueOf<typeof config.areaChartTimeframes>) => {
    const chartDataParams = useMemo(() => generateChartDataParams(timeframe), [timeframe]);

    const defaultData = useMemo(() => {
        const chartData = generateChartData(
            chartDataParams.startTime,
            parseEther('0'),
            chartDataParams.amountToGenerate,
            chartDataParams.timeInterval
        );
        return chartData.map(({ time, value }) => ({
            value: +formatEther(value),
            time: moment.unix(time).toISOString(),
        }));
    }, [chartDataParams]);

    const historicalProtocolFee = useMemo(
        () => generateMockData(timeframe, startValue, 0.03, cachedFees),
        [timeframe]
    );

    return {
        defaultData,
        historicalProtocolFee,
        isLoading: false,
        error: undefined,
        mutate: () => {},
    };
};

export default useMockHistoricalProtocolFees;
